import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { orgQueryKeys } from "./orgQueryKeys";

/**
 * Give every org without a model-configuration row the Roboto default
 * Bedrock row (Roboto admins). Resolves to how many rows were created, and
 * refetches the admin searches so the new rows show.
 */
export function useBackfillOrgModelConfigs() {
  const { orgService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<number, Error, void>({
    mutationFn: () => orgService.backfillOrgModelConfigs(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: orgQueryKeys.modelConfigSearches(),
      });
    },
  });
}
